'use strict';

export default angular.module('contartemx.preferencias.usuariospermisos', [
	'contartemx',
	'ui.router',
	'ngTable',
	'ui.bootstrap',
	'datePicker',
	"tableTools",
	"loader",
])
.controller('UsuariosCtrl', function ($scope, $state, $stateParams, NgTableParams, $filter, $http, $uibModal) {

var usuarios=[
{CveUsuario:1, Nombre:'Julian Varela',FechaSesion:'06/26/12',Email:'julian@itcuenta.com',Tipo:'Cuenta',EsInvitado:false},
{CveUsuario:2, Nombre:'Guillermo Alegre',FechaSesion:'07/25/12',Email:'galegre@arkusnexus.com',Tipo:'Personal',EsInvitado:false},
{CveUsuario:3, Nombre:'Jorge Arroyo',FechaSesion:'Invitado',Email:'julian@itcuenta.com',Tipo:'Cuenta',EsInvitado:true}
];

var usuarioseleccionado=[
{Nombre:'Guillermo Alegre', Email:'galegre@arkusnexus.com', EsEdicion:true}
];


$scope.usuarios=usuarios;
$scope.usuarioseleccionado=usuarioseleccionado;

 $scope.tableParams = new NgTableParams({
        page: 1,
        total: 1,
        count: 15,
        counts: [],
        sorting: {
            Nombre: "asc"
        }
    });

$scope.filtrosJSON = {
        FechaInicio: null,
        FechaFin: null,
        Cliente: null,
        folio: null,
        CveEstadoCliente: 0,
        cveTipoTransaccion: 0,
        IdentificadorEstadoFacturaFiltro: 0,
        CantidadRegistrosSolicitados: 15
    };

 $scope.$watch("tableParams", function (params, paramsOld) {

      
            $scope.startIndex = 0;
            $scope.filtrosJSON.IndiceInicial = $scope.startIndex;
            $scope.filtrosJSON.CantidadRegistrosSolicitados = params.count;
            if ('Nombre' in params.sorting) {
                $scope.filtrosJSON.ColumnaOrdenamiento = 1;
                $scope.filtrosJSON.EsDescendente = (params.sorting.Nombre === 'desc') ? true : false;
            }
            
        $scope.loading = false;
        var orderedData = $scope.tableParams.sorting ? $filter('orderBy')($scope.usuarios, $scope.tableParams.orderBy()) : $scope.usuarios;
        $scope.usuarios = orderedData.slice(($scope.tableParams.page - 1) * $scope.tableParams.count, $scope.tableParams.page * $scope.tableParams.count);
    }, true);

$scope.selectUsuarios = function (index) {
        
        $scope.selectedRow = index;
    }

    $scope.deselectUsuarios = function () {
        $scope.selectedRow = -1;
    }

    $scope.headerAction = function (index) {

        var selRow = $(".tabla-normal tr.selected").first();
        if (selRow) {
            var emailLink = selRow.find(".acciones a.send");
            var cveTransaccion = emailLink.attr("CveTransaccion");
            var cveCliente = emailLink.attr("CveCuentaCliente");
            var estaActiva = emailLink.attr("EstaActiva");
            var pdf = emailLink.attr("PDF");


            switch (index) {

                case 4:
                
                    var cancelarPop = $(".popoverTrCancel-popover");
                    
                    var cancelarEtiqueta = cancelarPop.find(".cancelarEtiqueta");
                    var cancelarBoton = cancelarPop.find(".cancelarBoton");
                    
                    if (estaActiva == "true") {
                        cancelarEtiqueta.html("&iquest;Eliminar Usuario?");
                        cancelarBoton.text("Cancelar");
                        cancelarBoton.css("background-color", "#FF0000");
                    } 

                    var actionCol = selRow.find(".acciones");
                    cancelarPop.css("left", actionCol.position().left);
                    cancelarPop.css("top", actionCol.position().top + (actionCol.height() / 2));
                    $("#contextmenu").removeClass("open");
                    break;
                default:
                    return;
            }
        }
    };



    $scope.displayNewItemModal = function(editar){
        var modalInstance = $uibModal.open({
            template: require('../../../../../app/views/Preferencias/Usuarios/Usuarios_modal.html'),
            controller: UsuariosNuevoCtrl,
            windowClass: 'modal--small',
             resolve:{
                usuariopermisos: function(){
                return $scope.usuario;
                },
                usrseleccion: function(){
                    if(editar)
                    {
                        
                        return $scope.usuarioseleccionado;
                    }
                    else
                    {
                        return;
                    }
                    
                }

            }
        });
    };

    var UsuariosNuevoCtrl = function($scope, $uibModalInstance, $http, $state, usuariopermisos, usrseleccion, mostrarNotificacion)
    {
        $scope.usuarioseleccionado=usrseleccion;
        $scope.usuariotipo = true;
        $scope.switchWindow = function (v, form) {
            if(v)
            {
                $scope.usuariotipo = false;
            }
            else
            {
                $scope.usuariotipo = true;
            }
        };

        $scope.closeModal = function (Respuesta){
            
        $uibModalInstance.dismiss('cancel');
        };

        $scope.saveChanges = function(formUsuarios){
            
            if (formUsuarios.$valid) 
            {
               if (formUsuarios.contrasenia) 
                {
                    if (formUsuarios.contrasenia.$viewValue && formUsuarios.confirmar_contrasenia.$viewValue) 
                    {
                        if (formUsuarios.contrasenia.$viewValue == formUsuarios.confirmar_contrasenia.$viewValue)
                        {
                        }
                        else 
                        {
                            $scope.alert = [];
                            $scope.alert.push({ type: 'error', msg: "Las contrase\u00F1as no coinciden" });
                        }
                    }
                    else 
                    {
                        $scope.alert = [];
                        $scope.alert.push({ type: 'error', msg: "Escribe y confirma la nueva contrase\u00F1a" });
                    }

                }
            }
            else
            {
                if(!formUsuarios.contrasenia.$viewValue && !formUsuarios.confirmar_contrasenia.$viewValue)
                {
                    $scope.alert.push({ type: 'error', msg: 'Faltan datos! Ingresa los datos donde aparece el simbolo azul' });
                }
                else if(!formUsuarios.contrasenia.$viewValue)
                {
                    $scope.alert = [];
                    $scope.alert.push({ type: 'error', msg: "Introduzca la contrase\u00F1a." });
                }
                else if(!formUsuarios.confirmar_contrasenia.$viewValue)
                {
                    $scope.alert = [];
                    $scope.alert.push({ type: 'error', msg: "Introduzca la confirmación de la contrase\u00F1a." });
                }
                




                
            }
        };

        $scope.alert = [];

        $scope.closeModalAlert = function (i) {
            
            $scope.alert.splice(i, 1);
        };

    };
    
    
});
